import { type FC } from 'react'

import { type OfferV11 } from '@redteclab/api/clients/bully'

import { Experiment } from '../../../../../experiments/components/Experiment'
import { ExperimentVariant } from '../../../../../experiments/components/ExperimentVariant'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP } from '../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../experiments/model/EXPERIMENT_VARIATION'
import { productAccessorGetSellerPromotionFromOffer } from '../../../../model/productAccessor/productAccessorGetSellerPromotionFromOffer'
import { ExperimentMarketplaceSellerPromotionHarmonisation } from '../../../ProductHead/ProductHeadLabels/ProductHeadLabelRenderer/ProductHeadSellerPromotionLabel/ExperimentMarketplaceSellerPromotionHarmonisation'
import { useProductPageContext } from '../../../productPageContext'
import { ProductSellerPromotionFlag } from '../../../ProductSellerPromotionFlag/ProductSellerPromotionFlag'

type ProductOfferCardSellerPromotionLabelProps = {
  offer: OfferV11
}

export const ProductOfferCardSellerPromotionLabel: FC<
  ProductOfferCardSellerPromotionLabelProps
> = ({ offer }) => {
  const sellerPromotion = productAccessorGetSellerPromotionFromOffer(offer)
  const { product } = useProductPageContext()

  if (!sellerPromotion) {
    return null
  }

  return (
    <Experiment names={[EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP]}>
      <ExperimentVariant name={EXPERIMENT_VARIATION.DEFAULT}>
        <button
          className="flex items-center rounded-full bg-light-brand-medium px-2.5 py-1 text-xs"
          data-qa-id="product-label-seller-promotion"
          type="button"
        >
          <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
        </button>
      </ExperimentVariant>
      <ExperimentVariant name={EXPERIMENT_VARIATION.V1}>
        <ExperimentMarketplaceSellerPromotionHarmonisation
          offer={offer}
          product={product}
          sellerPromotion={sellerPromotion}
        />
      </ExperimentVariant>
      <ExperimentVariant name={EXPERIMENT_VARIATION.V2}>
        <ExperimentMarketplaceSellerPromotionHarmonisation
          offer={offer}
          product={product}
          sellerPromotion={sellerPromotion}
        />
      </ExperimentVariant>
    </Experiment>
  )
}
